import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loading from "./Loading";
import { resolvePostAuthTarget } from "./lib/postAuthTarget";

// APP-2048: leave no history entry for the page that starts sign-in, so Back
// shows the previous page and not "Loading..." with "Log In".
export const protectedRouteLoginOptions = {
  openUrl: (url: string) => window.location.replace(url),
};

const ProtectedRoute = withAuthenticationRequired(React.Fragment, {
  loginOptions: protectedRouteLoginOptions,
  onRedirecting: () => <Loading />,
  // APP-1279: preserve the full URL (incl. query string) across the Auth0
  // redirect so deep links like /rebalances/today?q=… survive a cold load.
  // The SDK default returnTo is pathname only, which would drop ?q=.
  // APP-1282: but never capture the OAuth callback itself as the post-login
  // destination — by the time we'd navigate back, its single-use code is
  // consumed, which re-enters this guard and loops. Send those to "/".
  // resolvePostAuthTarget holds that shared rule (see lib/postAuthTarget).
  returnTo: () => resolvePostAuthTarget(undefined),
});

export default ProtectedRoute;
